import React, { useRef, useState, useEffect, useContext } from 'react'
import { message } from 'antd'
import Button from 'meinian-package/src/baseComponent/button'
import { Ul, Li, Dropdown } from 'meinian-package/src/baseComponent'
import util from 'meinian-package/src/utils/util'
import Icon from 'meinian-package/src/component/icon'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import request from 'meinian-package/src/utils/request'
import Collect from 'meinian-package/src/component/collect'
import { MARK_STATUS, getMarkStatusText } from 'meinian-package/src/component/enum'
import { isPermissions, teamHasAuth } from 'meinian-package/src/utils/auth'
import { renderMoveImage } from 'meinian-package/src/component/useFunModal/moveImage'
import SampleModal from 'component/imageDetail/sampleModal'
import { setSampleComplete } from 'component/imageDetail/sampleModal/common'
import {
  ExportStyle,
  QuickEditImage,
} from 'component/waterfall.card/style/image.base'
import Examine from '../../../../../../component/examine'
import RejectComment from '../../../../../../component/examine/rejectComment'
import noteRemind from '../../../../../../component/useFunModal/noteRemind'
import { MoreBtn } from '../../../../../../component/waterfall.card/action'
import PrintImage from '../../../../../../component/printImage'
import Upgrade from '../../../../../../component/imageDetail/upgradeImage'
import { ImageDetailContext } from '../../../content'
import imageDetailForceGuide, { GUIDE_KEYS } from '../../../forceGuideConfig'
import styles from './index.module.less'

export default ({ currentImage, imgInfoList, onInit, hasZkOfficialStyle }) => {
  const { markStatus, loginUserInfo,
    imageGroupEntityId, collectId, blogComment, userName, needMarkTimes, markTimes, platformId } = currentImage
  const auth = loginUserInfo?.inspirationPermissions || []
  const { queryParams, onChange, onBanOperation, onWrapInit, onVisibleChange, boxIndex } = useContext(ImageDetailContext)
  const { inspirationId } = queryParams
  const addSampleInfo = [{ inspirationId, blogId: imageGroupEntityId, platformId, collectId }]
  const [hasMarker, setHasMarker] = useState(false)
  const rejectCommentRef = useRef(null)
  const [sampleModalVisible, setSampleModalVisible] = useState()
  useEffect(() => {
    fetchHasMarker()
  }, [])

  const fetchHasMarker = async () => {
    const res = await request.get('/zhikuan/ins/inspiration/query-is-exist-marker', { params: { inspirationId } })
    setHasMarker(res)
  }

  const _onChange = (...arg) => {
    onChange?.(...arg)
    onInit()
  }
  const onDelete = () => {
    ModalConfirm.show({
      title: '确定要删除该款式吗？',
      content: '当款式被删除后，该款式将从当前灵感集中移除，相关的信息也将一并删除',
      onOk: async () => {
        await request.post('/ins/inspiration/remove-from-inspiration', {
          blogList: [{ blogId: imageGroupEntityId }],
          inspirationId
        })
        message.success('已成功删除')
        onVisibleChange(false)
        onWrapInit()
      },
    })
  }

  const onOkSampleModal = async (processId, option) => {
    addSampleInfo[0].processId = processId
    await setSampleComplete([{ ...addSampleInfo[0], ...option }], () => setSampleModalVisible(false))
    onBanOperation(false)
    onInit()
  }

  const domRef = useRef(null)
  imageDetailForceGuide.useEmit(GUIDE_KEYS.STEP_1, domRef, currentImage)

  return <div className={styles.infoBlockFooter}>
    <RejectComment
      ref={rejectCommentRef}
      rejectWindowClassName="image-detail-reject-comment-window"
      markStatus={markStatus}
      loginUserInfo={loginUserInfo}
      key={collectId}
      messageData={{
        userId: currentImage?.userId,
        inspirationId,
        blogId: imageGroupEntityId,
        collectOrSampleId: collectId,
        blogComment,
        type: 0
      }}
    />
    {
      !hasZkOfficialStyle ? <div className={styles['style-detail-button']} ref={domRef}>
        {auth.includes('FCS07') || auth.includes('FS06') ? <Examine.DetailText
          loginUserInfo={loginUserInfo}
          showIcon
          currentBlog={currentImage}
          className="examine-text"
          onChange={(_markStatus, _markTimes) => {
            _onChange?.(true, { markTimes: _markTimes, markStatus: _markStatus })
          }}
          auth={auth}
        /> : null}
        {hasMarker
          ? currentImage.hasMarkPermissions
            ? <Examine
                onInitiativeBehavior={(val) => {
                  rejectCommentRef.current?.onInitiativeBehavior(val)
                }}
                onCommentVisible={(val) => {
                  rejectCommentRef.current?.onCommentVisible(val)
                }}
                hiddenSample
                hiddenDetailDelete
                trackSourceType
                isRecallOperation={false}
                className="owner-examine"
                currentBlog={currentImage}
                onChange={(_markStatus, _markTimes) => {
                  _onChange?.(true, { markTimes: _markTimes, markStatus: _markStatus })
                }}
                wrapperClassName="image-detail-examine"
                type="detail"
            /> : (markStatus === MARK_STATUS.UNSET && isPermissions(auth, ['FS07', 'FS07_CREATOR', 'FCS08', 'FCS08_CREATOR'])) ? <Examine.Commit
              className="meinian-button ghost"
              currentBlog={currentImage}
              onChange={(_markStatus, _markTimes) => {
                _onChange?.(true, { markTimes: _markTimes, markStatus: _markStatus })
              }}
            >提交审核</Examine.Commit>
              : null
          : null}
        {/* 采集者不同状态的按钮 */}
        {
          (markStatus === MARK_STATUS.PENDING && !currentImage.hasMarkPermissions && isPermissions(auth, ['FS07', 'FS07_CREATOR', 'FCS08', 'FCS08_CREATOR']))
            ? <div className="meinian-examine-commit-button-recall-detail">
              {isPermissions(auth, ['FS18_CREATOR']) && <Button
                type="normal"
                style={{ marginRight: '8px' }}
                onClick={(e) => {
                  e.stopPropagation()
                  noteRemind({
                    option: {
                      userName,
                      collectId,
                      inspirationId,
                    },
                  })
                }}
              >
                短信提醒
              </Button>}
              <Examine.Recall
                className="meinian-button ghost"
                currentBlog={currentImage}
                onChange={(_markStatus, _markTimes) => {
                  _onChange?.(true, { markTimes: _markTimes, markStatus: _markStatus })
                }}
              />
            </div> : null
        }
        {
          (markStatus === MARK_STATUS.NOT_PASS && !currentImage.hasMarkPermissions && isPermissions(auth, ['FS04', 'FS04_CREATOR', 'FCS04', 'FCS04_CREATOR']))
            ? <>
              <Button type="normal" onClick={onDelete} style={{ marginRight: '8px' }}>删除</Button>
              {
                !!blogComment.length && <Examine.LeaveComment
                  style={{ marginRight: '8px' }}
                  onClick={(e) => {
                    e.stopPropagation()
                    rejectCommentRef.current?.onInitiativeBehavior(true)
                    rejectCommentRef.current?.onCommentVisible?.(pre => !pre)
                  }}
                />
              }
            </>
            : null
        }
        {isPermissions(auth, ['FS13', 'FCS14']) && teamHasAuth('meinian_sample_clothing') && getMarkStatusText(markStatus, { isPass: true, maxLevel: needMarkTimes, level: markTimes }) ? <span onClick={() => {
          if (markStatus !== MARK_STATUS.PASS) {
            currentImage.hasMarkPermissions ? message.info('升级样衣前，请先确保款式被审核通过哟。点击左侧的审核通过按钮，即可将款式审核通过~~')
              : message.info('升级样衣前，请先确保款式被审核通过哟，请联系灵感集的审核者来完成款式审核吧。如有疑问，请联系客服~~')
          }
        }}
        >
          <Button
            type="primary"
            style={{ height: 32, marginRight: 8, display: markStatus !== MARK_STATUS.PASS && 'none' }}
            onClick={() => {
              setSampleModalVisible(true)
              onBanOperation(true)
            }}
            disabled={markStatus !== MARK_STATUS.PASS}
          >设为样衣</Button>
        </span> : null}
        {isPermissions(auth, ['FCS07', 'FS06']) ? <MoreOperation
          collectId={collectId}
          platformId={platformId}
          onDelete={onDelete}
          setBanStatus={onBanOperation}
          onVisibleChange={onVisibleChange}
          onWrapInit={onWrapInit}
          boxIndex={boxIndex}
          currentImage={currentImage}
          imgInfoList={imgInfoList}
        /> : <div className="only-collect">
          <Collect
            hasCurInstated
            currentBlog={{ ...currentImage }}
            className="button"
          >
            <Button other style={{ width: 88 }}>采集</Button>
          </Collect>
        </div>}
      </div> : <div className={styles['style-detail-button']} ref={domRef}>
        <div className="only-collect">
          <Collect
            hasCurInstated
            currentBlog={{ ...currentImage }}
            className="button"
          >
            <Button other style={{ width: 88 }}>采集</Button>
          </Collect>
        </div>
      </div>
    }
    {sampleModalVisible && <SampleModal
      authList={auth}
      onClose={() => {
        setSampleModalVisible(false)
        onBanOperation(false)
      }}
      visible={sampleModalVisible}
      onOk={onOkSampleModal}
    />}
  </div>
}

const MoreOperation = (props) => {
  const {
    currentImage,
    onDelete,
    imgInfoList
  } = props
  const { queryParams,
    onInit,
    onBanOperation, onChange, onWrapInit, onVisibleChange, boxIndex, upgradeInfo, onDeleteItem } = useContext(ImageDetailContext)
  const { imageGroupEntityId, loginUserInfo } = currentImage || {}
  const auth = loginUserInfo?.inspirationPermissions || []
  const [visible, setVisible] = useState(false)

  const _upgradeChange = (success, itemParams) => {
    onInit()
    onChange(success, itemParams)
  }

  return <Dropdown
    trigger="hover"
    visible={visible}
    onVisibleChange={vis => setVisible(vis)}
    placement="bottomRight"
    overlay={<Ul style={{ width: 145 }}>
      {!isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) ? null : <>
        <Upgrade
          currentImage={currentImage}
          setBanStatus={onBanOperation}
          inspirationId={queryParams.inspirationId}
          noAuth={!isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR'])}
          blogId={queryParams.blogId}
          loginUserInfo={loginUserInfo}
          onDeleteItem={onDeleteItem}
          onChange={_upgradeChange}
          boxIndex={boxIndex}
        >
          <Li className="mn-dropdown-icon-li" onClick={() => setVisible(false)}><Icon type="m-bianji" />编辑</Li>
        </Upgrade>
        <QuickEditImage
          currentImage={upgradeInfo}
          blogId={queryParams.blogId}
          setVisible={setVisible}
          onDeleteItem={onDeleteItem}
          inspirationId={queryParams.inspirationId}
          setBanStatus={onBanOperation}
          boxIndex={boxIndex}
          onChange={() => {
            onInit()
          }}
        >
          <Li className="mn-dropdown-icon-li" onClick={() => setVisible(false)}><Icon type="m-kuaisubianji" />快速编辑</Li>
        </QuickEditImage>
        <div className="li-partition" />
      </>}
      <Collect hasCurInstated currentBlog={{ ...currentImage }} className="button">
        <Li className="mn-dropdown-icon-li" onClick={() => setVisible(false)}><Icon type="m-caiji" />采集</Li>
      </Collect>
      {isPermissions(auth, ['FS04', 'FS04_CREATOR', 'FCS04', 'FCS04_CREATOR']) ? <Li
        className="mn-dropdown-icon-li"
        onClick={() => {
          renderMoveImage({
            blogId: imageGroupEntityId,
            blog: currentImage,
            fromInspirationId: queryParams.inspirationId,
            onChange: () => {
              onVisibleChange(false)
              onWrapInit()
            }
          })
        }}
      ><Icon type="m-yidong" onClick={() => setVisible(false)} />移动</Li> : null}
      {isPermissions(auth, ['FCS07', 'FS06']) ? <ExportStyle
        id={queryParams.collectId}
        fileName={upgradeInfo?.inspirationName || '款式'}
        onChange={() => {
          util.track('mn-statement-export', {
            module1: '单款导出',
            module2: '款式详情导出'
          })
        }}
      >
        <Li className="mn-dropdown-icon-li" onClick={() => setVisible(false)}><Icon type="m-daochu" />导出</Li>
      </ExportStyle> : null}
      {isPermissions(auth, ['FS14', 'FCS15']) ? <PrintImage
        imageInfo={imgInfoList}
        upgradeInfo={upgradeInfo}
        unionId={props.unionId}
        blogId={imageGroupEntityId}
        inspirationId={queryParams.inspirationId}
        platformId={props.platformId}
      >
        <div onClick={() => setVisible(false)}>
          <Li className="mn-dropdown-icon-li" onClick={() => { request.track({ code: 6400034, type: '款式详情-打印' }) }}><Icon type="m-dayin" />打印</Li>
        </div>
      </PrintImage> : null}
      {isPermissions(auth, ['FS11', 'FCS12']) && teamHasAuth('meinian_style_receipts')
        ? <>
          <div className="li-partition" />
          <Li className="mn-dropdown-icon-li">{currentImage.markStatus === MARK_STATUS.PASS ? <div
            onClick={() => {
              setVisible(false)
              window.open(`/meinian/editProcess?collectId=${queryParams.collectId}&imageGroupEntityId=${imageGroupEntityId}&inspirationId=${queryParams.inspirationId}&blogId=${queryParams.blogId}&unionId=${props?.unionId}&platformId=${props?.platformId}`, '_blank')
            }}
          ><Icon type="m-bianji" />编辑制版单</div> : <div onClick={() => message.error('当前款式未审核通过，不可编辑制版单哦-_-')}><Icon type="m-bianji" />编辑制版单</div>}</Li>
        </> : null}
      {isPermissions(auth, ['FS12', 'FCS13']) && teamHasAuth('meinian_style_receipts')
        ? <Li className="mn-dropdown-icon-li">{currentImage.markStatus === MARK_STATUS.PASS ? <div
            onClick={() => {
              setVisible(false)
              window.open(`/api/zhikuan/style-receipts/export?blogId=${imageGroupEntityId}&inspirationId=${queryParams.inspirationId}`, '_self')
            }}
        ><Icon type="m-xiazai" />下载制版单</div> : <div onClick={() => message.error('当前款式未审核通过，不可生成制版单哦-_-')}><Icon type="m-xiazai" />下载制版单</div>}</Li> : null}
      {isPermissions(auth, ['FS04', 'FS04_CREATOR', 'FCS04', 'FCS04_CREATOR']) ? <>
        <div className="li-partition" />
        <Li className="mn-dropdown-icon-li delete" onClick={onDelete}><Icon type="m-shanchu" />删除</Li>
      </> : null}
    </Ul>}
  >
    <MoreBtn style={{ cursor: 'pointer' }} />
  </Dropdown>
}
